// React
import React from "react";

// Libraries
import PropTypes from "prop-types";

// Components
import Text from "@Components/Text";
import DocumentCard from "../../../DownloadCard";

// Styles
import styles from "./styles.module.css";

const DocumentContent = ({ item, onClick }) => {
	const tmp = item.uri.split("/");
	const fileName = tmp[tmp.length - 1];

	return (
		<div>
			<DocumentCard fileName={fileName} withButton onClick={onClick} />
			<Text className={styles.text} withMarkdown>
				{item.text}
			</Text>
		</div>
	);
};

DocumentContent.propTypes = {
	item: PropTypes.object,
	onClick: PropTypes.func,
};

export default DocumentContent;
